// Components
import KOGImage from "@/main/components/shared/kogImage/kogImage";
import QuoteProcurementPartInfo, {
	getTooltipFormatted,
} from "@/main/components/shared/quoteProcurementPartInfo/quoteProcurementPartInfo";

// Utils
import { IMAGE_DEFAULT } from "@/main/services/constants";
import { getTranslateByKey, isNullUndefined, isShowControlByElementId } from "@/main/services/utils";

// Models
import { QuoteNoSupplierAssignedItemResponse, QuoteNoSupplierAssignedResponse } from "@/main/models/response";
import { Controls } from "@/main/services/constants/constantsControl";
import { formatCurrency } from "@/main/services/utilsNumber";

// Styles/Components Local
import * as S from "./styles";

interface DetailsCartSupplierRequotedUnansweredProps {
	cart: QuoteNoSupplierAssignedResponse | null;
	part: QuoteNoSupplierAssignedItemResponse;
	loadCart: (guidQuote: string) => void;
}
function DetailsCartSupplierRequotedUnanswered({ part }: DetailsCartSupplierRequotedUnansweredProps) {
	const showPrices = isShowControlByElementId(Controls.IdShowPrices);

	return (
		<S.ContainerPartNoCollpase>
			<S.WrapperHeaderNoCollpase>
				<S.BodyBox key={part.guidQuoteItem} style={{ position: "initial" }}>
					<S.ContainerPart>
						<KOGImage width={80} height={80} src={IMAGE_DEFAULT} />
						<S.PartInfo title={getTooltipFormatted(part.quoteProcurementPartInfo)}>
							<QuoteProcurementPartInfo
								data={part.quoteProcurementPartInfo}
								renderType="column"
								isTooltip
								showIconNotes
							/>
						</S.PartInfo>
						{showPrices && !isNullUndefined(part.priceCap) && (
							<S.TextPriceCap>
								{`${getTranslateByKey("information.priceCap")}: ${formatCurrency(part.priceCap)}`}
							</S.TextPriceCap>
						)}
					</S.ContainerPart>
				</S.BodyBox>
			</S.WrapperHeaderNoCollpase>
		</S.ContainerPartNoCollpase>
	);
}

interface BoxCartUnansweredRequotedItemsProps extends Omit<DetailsCartSupplierRequotedUnansweredProps, "part"> {}
function BoxCartUnansweredRequotedItems(props: BoxCartUnansweredRequotedItemsProps) {
	if (isNullUndefined(props.cart) || props.cart.parts == null || props.cart.parts.length === 0) return null;

	return (
		<S.ContainerBox>
			<S.HeaderBox>
				<S.ContainerTitleBox>
					<S.TitleBox>{getTranslateByKey("information.requotedParts")}</S.TitleBox>
				</S.ContainerTitleBox>
			</S.HeaderBox>
			<S.ContentBox>
				{props.cart.parts.map((part) => (
					<DetailsCartSupplierRequotedUnanswered key={part.guidQuoteItem} {...props} part={part} />
				))}
			</S.ContentBox>
		</S.ContainerBox>
	);
}

export default BoxCartUnansweredRequotedItems;
